export default __webpack_public_path__ + "static/media/tick.8349a100.svg";